import "./DocumentCard.scss";
import {useNavigate} from "react-router-dom";
import Avatar from "../../components/Avatar/Avatar";
import Icon, {editIcon, trashIcon} from "../../components/Icon/Icon";

const DocumentCard = ({document, onEdit, onDelete}) => {
    const navigate = useNavigate();

    const handleOpenDocument = () => {
        navigate(`/documents/document/${document.id}`);
    };

    return (
        <div
            className="document-item"
            style={{backgroundColor: document.color}}
            onClick={handleOpenDocument}
        >
            <div className="document-actions">
                <button
                    type="button"
                    className="action-button edit"
                    title="Edit document"
                    aria-label="Edit document"
                    onClick={(e) => {
                        e.stopPropagation();
                        onEdit?.(document);
                    }}
                >
                    <Icon svg={editIcon}/>
                </button>

                <button
                    type="button"
                    className="action-button delete"
                    title="Delete document"
                    aria-label="Delete document"
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete?.(document);
                    }}
                >
                    <Icon svg={trashIcon}/>
                </button>
            </div>

            <div className="info">
                <Avatar
                    name={document.user.name}
                    surname={document.user.surname}
                    url={document.user.image?.url}
                    className="avatar"
                />

                <div className="details">
                    <div className="title">{document.name}</div>
                    <div className="description">{document.description}</div>
                </div>
            </div>
        </div>
    );
};

export default DocumentCard;